import React from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'

import blogs_js from './articles.js';
import StartFooterCTA from './StartFooterCTA.js'


class BlogPost extends React.Component {

  constructor(props) {
    super(props);

    let article_id = false;
    let blog_path = this.props.pathname.replace("/blog-post/", "");
    if(blog_path !== "" && blog_path !== "/blog-post") {
      let splitted = blog_path.split("-");
      if(splitted.length > 0) {
        article_id = splitted.pop()-1;
      }
    } else {
      this.props.push("/blog");
    }

    blogs_js.sort((a,b)=>a-b);
    blogs_js.reverse();

    this.state = {article_id};
  }

  render() {
    let article_title = "404 Not Found: Artikel niet gevonden.";
    let found_article = false;
    let found_article_id = 0;
    for(let i = 0; i < blogs_js.length; i++) {
      if(i === parseInt(this.state.article_id, 10)) {
        let article = blogs_js[i];
        article_title = article.title;
        found_article_id = i;
        found_article = <article key={"a_"+i}>
          <img src={article.img} alt={"citrus.polymedia.nl | "+article.title} className="screenshot" />
          <h1>{article.title}</h1>
          <small><time dateTime={article.date}>{article.date.substring(8,10)+"-"+article.date.substring(5,7)+"-"+article.date.substring(0,4)}</time> | <a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer">Peter van der Meer</a></small>
          <div dangerouslySetInnerHTML={{__html:article.text}} />
        </article>;
      }
    }
    document.title = article_title+" · Blog · Citrus by Polymedia";

    return (
      <div className="start">

        <div className="full greyish blog">
          <div className="wrap" style={{maxWidth:"720px"}}>

            {found_article && <small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"12px", textAlign:"right"}}>{this.props.i18n_texts["gen_lastmodified"][this.props.app_language]} <time dateTime={blogs_js[found_article_id].date}>{blogs_js[found_article_id].date.substring(8,10)+"-"+blogs_js[found_article_id].date.substring(5,7)+"-"+blogs_js[found_article_id].date.substring(0,4)}</time>.</small>}

            {found_article && <a href="/blog">terug naar overzicht</a>}

            {found_article}

            {!found_article && <div>404 Not Found: Artikel niet gevonden.</div>}

            {found_article && <div style={{margin:"3em 0"}} dangerouslySetInnerHTML={{__html: '<iframe src="https://citrus.polymedia.nl/articlefeedback/q7roDYfVgtAQaLfwP4VWvmhu4K8j816J?embed" height="87" style="border:0;width:100%"></iframe>'}} />}

            <a href="/blog">terug naar overzicht</a>

          </div>
        </div>

        <StartFooterCTA lang={this.props.app_language} openModal={this.props.openModal} />

      </div>
    );
  }

}


function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogPost)



// WEBPACK FOOTER //
// ./src/containers/StartPages/BlogPost.js